import { render, staticRenderFns } from "./warm.vue?vue&type=template&id=c67c28cc&scoped=true&"
import script from "./warm.vue?vue&type=script&lang=js&"
export * from "./warm.vue?vue&type=script&lang=js&"
import style0 from "./warm.vue?vue&type=style&index=0&id=c67c28cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67c28cc",
  null
  
)

export default component.exports